
 export const navigateToLogin = async () => {
   window.location.href = "/login";
}

let logoutFunc = null;
export const setLogoutFunc = (func) => {
   logoutFunc = func;
}
 export const navigateToLogout = async () => {
  logoutFunc({ logoutParams: { returnTo: window.location.origin + "/app" } })
}